import Shortcut from 'components/Shortcut';
import { Row, Col } from 'antd';

const ShortcutSection = () => {
  return (
    <section className="pt-5" id="above-content" role="complementary" aria-label="Approfondimenti">
      <Row gutter={10 /* 4 */} style={{ rowGap: '4px' }}>
        <Col xs={24} md={8}>
          <Shortcut
            link="/home/codifiche-territoriali"
            title="Codifiche territoriali per la PA e il Paese"
            level={2}
            tabIndex={0}
            className="mb-1 mb-md-1"
          />
        </Col>
        <Col xs={24} md={8}>
          <Shortcut
            link="/home/caratteristiche-classificazioni"
            title="Caratteristiche e classificazioni delle unità territoriali"
            level={2}
            tabIndex={0}
            className="mb-1 mb-md-1"
          />
        </Col>
        <Col xs={24} md={8}>
          <Shortcut
            link="/home/cambiamenti-unita-territoriali"
            title="Cambiamenti delle unità territoriali"
            level={2}
            tabIndex={0}
            className="mb-1 mb-md-1"
          />
        </Col>
        {/* FASE 3 - BOX OSCURATO
        <Col xs={12} md={6}>
          <Shortcut
            link="/home/geo-eu-clas"
            title="Geografie europee e relative classificazioni"
            level={2}
            tabIndex={0}
          />
        </Col>
        */}
      </Row>
    </section>
  );
};

export default ShortcutSection;
